// Path: ./src/utils/commonStyledComponents/commonMuiStyled.ts
import { Button, ButtonProps, styled as MuiStyled } from "@mui/material";

export const BlackFontTransparentButton = MuiStyled(Button)<ButtonProps>(
  () => ({
    color: "black",
    backgroundColor: "transparent",
    fontSize: 18,
    "&:hover": {
      backgroundColor: "transparent",
    },
  })
);

export const ColorButton = MuiStyled(Button)<ButtonProps>(() => ({
  backgroundColor: "#f58220",
  textTransform: "capitalize",
  fontSize: 18,
  "&:hover": {
    backgroundColor: "#f58220",
  },
})); //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) duplicate

export const CancelButton = MuiStyled(Button)<ButtonProps>(() => ({
  backgroundColor: "white",
  textTransform: "capitalize",
  color: "black",
  marginRight: 20,
  fontSize: 18,
  "&:hover": {
    backgroundColor: "white",
  },
})); //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) duplicate
